import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InteractionLogDirective } from './interaction-log.directive';

@NgModule({
  declarations: [InteractionLogDirective],
  exports: [InteractionLogDirective],
  imports: [CommonModule]
})
export class LogModule {}
